<!-- 上传图片 基于 Vant UI -->
<template>
    <div class="uploader-box">
        <van-uploader :max-count="1" :max-size="uploaderMaxSize.imageMaxSize * 1024" @oversize="_onOversize" :after-read="afterRead" />
    </div>
</template>
<script>
import {
    QiniuUpload
} from "../utils/qiniuUpload";
import {
    mapGetters,
    mapActions,
} from 'vuex'

export default {
    name: "upload-vant",
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            qiniuInfo: {},
            uploaderMaxSize: {},
        };
    },
    created() {
        this.getQiniuData()
    },
    methods: {
        _onOversize(file) {
            console.log('file---->', file);
            this.ToastManager('图片大小不能超过：' + (this.uploaderMaxSize.imageMaxSize / 1024) + 'M');
        },
        // 图片选择回调
        afterRead(file) {
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_QINIUKODO) {
                QiniuUpload(this.qiniuInfo, file)
                    .then((res) => {
                        let img_src = this.qiniuInfo.domain + res.key;
                        this.Message({
                            message: "上传中",
                            type: 4,
                            time: 500,
                        });
                        console.log('res---->', res);
                        this.$emit('callback', img_src);
                    })
                    .catch((err) => {
                        console.log('err------------->', err)
                    });
            }
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_ALIOSS) {
                this._onUploadImageToAliOss(file);
            }
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_TENCENTCOS) {

            }
        },
        // 获取七牛云配置
        async getQiniuData() {
            let url = this.API.qiniuToken;
            let params = {};
            let result = await this.$post(url, params);
            this.qiniuInfo = result;
            this.uploaderMaxSize = result.uploaderMaxSize;
        },
        // 上传阿里云
        async _onUploadImageToAliOss(file) {
            let url = this.API.uploadToAliOss;
            let params = {
                file: file.file,
                uid: this.userInfo.id,
            };
            this.Message({
                message: "上传中",
                type: 4,
                time: 500,
            });
            let result = await this.$uploadFormData(url, params);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                this.$emit('callback', result.url);
            }
        },
    },
};
</script>
<style lang="less" scoped>
.uploader-box {
    /deep/ .van-uploader__upload {
        margin: 0;
    }

    /deep/ .van-uploader__upload {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    /deep/ .van-uploader__preview {
        margin: 0;
    }

    /deep/ .van-uploader__preview-image {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    /deep/ .van-uploader__file {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
}
</style>